import Cookies from 'js-cookie'
import { getPersistedItem, setPersistedItem } from 'utils/persistedStorage.ts'
import {
  FEEDBACK_WIDGETS_DISMISSED_DAYS,
  FEEDBACK_WIDGETS_DISMISSED_STORAGE_KEY,
  LEGACY_FEEDBACK_WIDGET_COOKIE_PREFIX
} from './constants.ts'

/**
 * Checks if the user dismissed a feedback widget in the last 30 days
 *
 * @param {string} [fixedFeedbackWidgetId]
 * @returns {boolean}
 */
export const hasDismissedFeedbackWidgets = (fixedFeedbackWidgetId?: string): boolean => {
  if (getPersistedItem(FEEDBACK_WIDGETS_DISMISSED_STORAGE_KEY)) return true

  // Legacy per-widget cookies (removable 30 days after release) count as a dismissal of every widget, except the fixed widget's own
  return Object.keys(Cookies.get()).some(
    (name) =>
      name.startsWith(LEGACY_FEEDBACK_WIDGET_COOKIE_PREFIX) && name !== `${LEGACY_FEEDBACK_WIDGET_COOKIE_PREFIX}${fixedFeedbackWidgetId}`
  )
}

/**
 * Hides all non-fixed feedback widgets for 30 days
 */
export const dismissFeedbackWidgets = (): void => {
  setPersistedItem(FEEDBACK_WIDGETS_DISMISSED_STORAGE_KEY, 'hidden', FEEDBACK_WIDGETS_DISMISSED_DAYS)
}
